import './App.css';
import Radio from './Radio'

function App() {
  return (
    <div className="App">
      <h1>React Popovic Radio</h1>
      <h3>Pick a genre and start listening!</h3>
      <Radio />
    </div>
  );
}

export default App;
